import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { Component } from '@theme/component';

/**
 * A custom element that displays a product variant's custom.variant_description metafield.
 * This component listens for variant update events and updates the description display accordingly.
 *
 * @extends {Component}
 */
class VariantDescriptionComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateDescription);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateDescription);
  }

  /**
   * Updates the variant description from the server-rendered HTML response.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateDescription = (event) => {
    const newProduct = event.detail?.data?.newProduct;
    if (newProduct) {
      this.dataset.productId = newProduct.id.toString();
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const htmlResponse = event.detail?.data?.html;
    if (!htmlResponse) return;

    const newComponent = htmlResponse.querySelector(
      `variant-description-component[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newComponent) {
      this.style.display = 'none';
      return;
    }

    const newContainer = newComponent.querySelector('[ref="descriptionContainer"]');
    const container = this.querySelector('[ref="descriptionContainer"]');

    if (!newContainer || !container) {
      this.style.display = 'none';
      return;
    }

    const newContent = newContainer.innerHTML.trim();
    if (newContent === '') {
      this.style.display = 'none';
    } else {
      this.style.display = '';
      container.innerHTML = newContent;
    }
  };
}

if (!customElements.get('variant-description-component')) {
  customElements.define('variant-description-component', VariantDescriptionComponent);
}
